import { useAxios } from '@project44/ui-utils';

import {
  MOVEMENT_LOGIN_PAGE,
  PORTAL_V2_PUBLIC_API_BASE_URL,
} from '../utils/constants';
import { UseDetermineSsoType } from '../utils/types';

export const useDetermineSso = (): UseDetermineSsoType => {
  const [dataState, axiosRequestHandler] = useAxios<{
    redirectURL: string | null;
    state: string;
  }>();
  const determineSSO = async (options: {
    idpId: string | null;
    username: string | null;
  }) => {
    await axiosRequestHandler({
      method: 'POST',
      url: `${PORTAL_V2_PUBLIC_API_BASE_URL}/determineSSO`,
      data: {
        idpId: options.idpId,
        username: options.username,
        loginPageUrl: MOVEMENT_LOGIN_PAGE,
      },
      withCredentials: true,
    });
  };

  return [dataState, determineSSO];
};
